var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBell = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.076 2.117A1 1 0 0 0 7 2.5h2a1 1 0 0 0-1.924-.383z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.75 7.5v2.75H2a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-.75V7.5A4.75 4.75 0 0 0 8.5 2.75h-1A4.75 4.75 0 0 0 2.75 7.5zM7.5 4.25A3.25 3.25 0 0 0 4.25 7.5v2.75h7.5V7.5A3.25 3.25 0 0 0 8.5 4.25h-1z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.945 14.116a2.75 2.75 0 0 1-3.89 0l-.085-.086a.75.75 0 0 1 .53-1.28h3a.75.75 0 0 1 .53 1.28l-.085.086z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export default ForwardRef;